module.exports = __webpack_public_path__ + "static/media/benjamin.52e5d443.png";